import React, { useEffect, useState } from "react";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import accessoriesService from "../../../services/accessories.service";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

const headerCells = [
  {
    field: "name",
    title: "نام",
    mainField: true,
  },
];

export default function AccessoryCategoriesPage() {
  const [data, setData] = useState([]);
  const deleteItem = (item) => {
    return accessoriesService.deleteAccessoryCategory(item.id);
  };

  useEffect(() => {
    onRefresh();
  }, []);

  const onRefresh = async () => {
    const { data, error } = await accessoriesService.getAccessoryCategories();
    if (error) {
      // handleError(error);
      return;
    }
    setData(data);
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        data={data}
        onRefresh={onRefresh}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد گروه اکسسوری",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title="گروه‌های اکسسوری‌"
      />
    </div>
  );
}
